<p-toast></p-toast>
<div class="h-full center-container">
    <div class="grid w-full">
        <div class="col-12">
            <p-toolbar>
                <div class="p-toolbar-group-center w-full">
                    <div class="field mb-0 col-12">
                        <div class="col-6 flex align-content-left justify-content-start align-items-center">
                            <h3 #componentTitleHeader class="m-0">Daily Import Summary Settings {{ locationId }}</h3>
                        </div>
                    </div>
                </div>
            </p-toolbar>
            <div class="col-12">
                <div *ngIf="!loadingSettings; else spinner">
                    <form [formGroup]="settingsForm" autocomplete="off">
                        <div class="formgrid grid p-fluid mt-5">
                            <div class="field col-12">
                                <label for="daily_summary_report_type"
                                    class="label-required w-3 flex align-items-center">Daily Summary Report Type</label>
                                <p-dropdown formControlName="daily_summary_report_type" id="daily_summary_report_type" [options]="reportTypeOptions"
                                    optionLabel="name" optionValue="code" appendTo="body" styleClass="w-full">
                                </p-dropdown>
                            </div>
                            @if(settingsForm.value['daily_summary_report_type'] == 'surepark') {
                                <div class="field col-12">
                                    <div class="field mb-0">
                                        <label for="parking_device" class="label-required w-full">Calculate Revenue
                                            Method</label>
                                        <div *ngFor="let method of calculateRevenueMethods" class="field-checkbox mb-0">
                                            <div class="flex justify-content-between">
                                                <label for="{{method.key}}" class="ml-2">
                                                    {{ method.name }}
                                                </label>
                                                <p-radioButton formControlName="daily_summary_calculate_revenue_method"
                                                    inputId="{{method.key}}" [value]="method.key" />
                                            </div>
                                        </div>
                                    </div>
                                    <small class="text-gray-600 w-full mt-2">
                                        When "Use Validated and Non-Validated Income" checked following formula will be
                                        consider <b>(Validated + Non-Validated) - Credit Card fee</b>
                                        <br />
                                        When "Use Revenue Summary" checked <b>'Revenue section' 'Summary' amount</b> will be
                                        consider
                                    </small>
                                </div>
                                <div class="field col-12">
                                    <div class="field-checkbox mb-0 gap-5 w-full">
                                        <label for="daily_summary_dont_report_cc_fees" class="label-required w-3">Do Not
                                            Report
                                            Credit Card Fees</label>
                                        <p-inputSwitch pInputText id="daily_summary_dont_report_cc_fees"
                                            formControlName="daily_summary_dont_report_cc_fees"
                                            class="border-none w-auto" />
                                    </div>
                                    <small class="text-gray-600 w-full mt-2">
                                        When checked credit card fees won’t be reported on the DRE ‘Other Income’ grid OR
                                        subtracted from the revenue.
                                    </small>
                                </div>
                                <div class="field col-12">
                                    <div class="field-checkbox mb-0 gap-5 w-full">
                                        <label for="daily_summary_dont_track_lost_tickets" class="label-required w-3">Do Not
                                            Include Lost Tickets</label>
                                        <p-inputSwitch pInputText id="daily_summary_dont_track_lost_tickets"
                                            formControlName="daily_summary_dont_track_lost_tickets"
                                            class="border-none w-auto" />
                                    </div>
                                    <small class="text-gray-600 w-full mt-2">
                                        When checked lost tickets won’t be reported on the DRE.
                                    </small>
                                </div>
                                <div class="field col-12">
                                    <div class="field-checkbox mb-0 gap-5 w-full">
                                        <label for="daily_summary_report_cc_fees_to_tickets_collected"
                                            class="label-required w-3">Report Credit Card Fees To Tickets Collected</label>
                                        <p-inputSwitch pInputText id="daily_summary_report_cc_fees_to_tickets_collected"
                                            formControlName="daily_summary_report_cc_fees_to_tickets_collected"
                                            class="border-none w-auto" />
                                    </div>
                                    <small class="text-gray-600 w-full mt-2">
                                        When selected credit card fees from the summary revenue grid will be added as a new
                                        line item in the ‘Tickets Collected' grid.
                                    </small>
                                </div>
                                <div class="field col-12">
                                    <div class="field-checkbox mb-0 gap-5 w-full">
                                        <label for="daily_summary_enable_multi_shift" class="label-required w-3">Enable Multi Shift</label>
                                        <p-inputSwitch pInputText id="daily_summary_enable_multi_shift"
                                            formControlName="daily_summary_multi_shift_enabled"
                                            class="border-none w-auto" />
                                    </div>
                                    <!-- <small class="text-gray-600 w-full mt-2">
                                        When checked credit card fees won’t be reported on the DRE ‘Other Income’ grid OR
                                        subtracted from the revenue.
                                    </small> -->
                                </div>
                            }
                            <div class="field col-12 md:col-6">
                                <div class="col-6 flex align-content-left justify-content-start">
                                    <a pButton class="no-underline w-auto" severity="primary" label="Back to Portal"
                                        (click)="backToPortal()"></a>
                                </div>
                                <div class="col-6 flex align-content-center justify-content-end">
                                    <p-button class="col-offset-6 mt-2" label="Save Settings" id="save_settings"
                                        (click)="saveSettings(settingsForm.value)"
                                        [loading]="savingSettings"></p-button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <ng-template #spinner>
                <p-progressSpinner></p-progressSpinner>
            </ng-template>
        </div>
    </div>
</div>